<template>
  <div class="app-header flex-col">
    <div class="top-bar flex-row align-center" @click="goHome()">
      <img
        class="logo-img"
        referrerpolicy="no-referrer"
        src="../assets/img/icon-header-logo.png"
      />
      <span class="title-text">生态保护与修复报道中心</span> 
    </div>
    <div class="subtitle flex-col">
      <div class="subtitle-row flex-row justify-between">
        <span>宣传环境法治</span>
        <span>聚焦环境舆情</span>
        <span>推动环境治理</span>
        <span>践行社会责任</span>
      </div>
      <div class="subtitle-row flex-row justify-between">
        <span>生态智慧应急</span>
        <span>新型应对机制</span>
        <span>融合现代科技</span>
        <span>保护生态环境</span>
      </div>
    </div>
    <div class="hero-area flex-col">
      <div class="banner-placeholder flex-col align-center justify-center" v-if="banners.length === 0">
        <p class="placeholder-text">暂无幻灯</p>
      </div>
      <div class="banner-swiper" v-else @touchstart="onTouchStart" @touchend="onTouchEnd">
        <div class="banner-track" :style="{ transform: `translateX(-${currentIndex * 100}%)` }">
          <div
            v-for="(img, idx) in banners"
            :key="idx"
            class="banner-slide"
          >
            <img :src="img" class="banner-img" />
          </div>
        </div>
        <div class="banner-dots">
          <span
            v-for="(img, idx) in banners"
            :key="idx"
            class="dot"
            :class="{ active: idx === currentIndex }"
            @click="goTo(idx)"
          ></span>
        </div>
      </div>
      <!-- <img
        class="status-bar-img"
        referrerpolicy="no-referrer"
        src="../assets/img/phone-status-bar.png"
      /> -->
    </div>
  </div>
</template>

<script>
import { contentList } from '../../api/content'
import { getColumnIdByName } from '../../utils/common'

export default {
  name: 'AppHeader',
  data() {
    return {
      banners: [],
      currentIndex: 0,
      timer: null,
      touchStartX: 0
    }
  },
  mounted() {
    this.fetchBanners()
  },
  beforeDestroy() {
    this.stopAutoPlay()
  },
  methods: {
    goHome(){
      this.$router.push('/')
    },
    async fetchBanners() {
      try {
        const categoryId = getColumnIdByName('幻灯')
        if (!categoryId) return
        const { rows } = await contentList({ categoryId })
        if (!Array.isArray(rows)) return
        this.banners = rows
          .map((item) => {
            if (!item.litpic) return null
            try {
              const pics = JSON.parse(item.litpic)
              return pics && pics[0] ? pics[0].url : null
            } catch (e) {
              return null
            }
          })
          .filter(Boolean)
        this.startAutoPlay()
      } catch (e) {
        console.error('获取幻灯数据失败', e)
      }
    },
    startAutoPlay() {
      this.stopAutoPlay()
      if (!this.banners.length) return
      this.timer = setInterval(() => {
        this.currentIndex = (this.currentIndex + 1) % this.banners.length
      }, 3000)
    },
    stopAutoPlay() {
      if (this.timer) {
        clearInterval(this.timer)
        this.timer = null
      }
    },
    goTo(idx) {
      this.currentIndex = idx
      this.startAutoPlay()
    },
    onTouchStart(e) {
      this.touchStartX = e.touches[0].clientX
      this.stopAutoPlay()
    },
    onTouchEnd(e) {
      const deltaX = e.changedTouches[0].clientX - this.touchStartX
      if (deltaX > 50) {
        this.currentIndex = this.currentIndex === 0 ? this.banners.length - 1 : this.currentIndex - 1
      } else if (deltaX < -50) {
        this.currentIndex = (this.currentIndex + 1) % this.banners.length
      }
      this.startAutoPlay()
    }
  }
}
</script>

<style scoped lang="scss">
.app-header {
  width: 375px;
  background: url(../assets/img/bg-header.png) 100% no-repeat;
  background-size: 100% 100%;

  .top-bar {
    width: 100%;
    height: 40px;
    padding-left: 16px;
    padding-right: 15px;
    cursor: pointer;

    .logo-img {
      width: 28px;
      height: 28px;
      cursor: pointer;
      transition: transform 0.15s cubic-bezier(0.4, 0, 0.2, 1), opacity 0.15s cubic-bezier(0.4, 0, 0.2, 1);

      &:active {
        transform: scale(0.85);
        opacity: 0.8;
      }
    }

    .title-text {
      flex: 1;
      min-width: 0;
      margin-left: 8px;
      overflow: hidden;
      text-overflow: ellipsis;
      color: rgba(255, 255, 255, 1);
      font-size: 16px;
      font-family: PingFangSC-Semibold;
      font-weight: 600;
      white-space: nowrap;
      line-height: 22px;
    }

    .menu-icon {
      width: 16px;
      height: 16px;
      margin-left: 8px;
      cursor: pointer;
      transition: transform 0.15s cubic-bezier(0.4, 0, 0.2, 1), opacity 0.15s cubic-bezier(0.4, 0, 0.2, 1);

      &:active {
        transform: scale(0.85);
        opacity: 0.8;
      }
    }
  }

  .subtitle {
    width: 340px;
    overflow-wrap: break-word;
    color: rgba(255, 255, 255, 1);
    font-size: 12px;
    text-align: left;
    line-height: 20px;
    align-self: center;
    margin-top: 2px;

    .subtitle-row {
      span {
        cursor: pointer;
        transition: transform 0.15s cubic-bezier(0.4, 0, 0.2, 1), opacity 0.15s cubic-bezier(0.4, 0, 0.2, 1);

        &:active {
          transform: scale(0.9);
          opacity: 0.75;
        }
      }
    }
  }

  .hero-area {
    width: 343px;
    align-self: center;
    margin-top: 8px;

    .banner-placeholder {
      width: 100%;
      height: 160px;
      background: rgba(255, 255, 255, 0.15);
      border-radius: 11px;
    }
    .placeholder-text {
      font-size: 14px;
      color: rgba(255, 255, 255, 0.6);
      margin: 0;
    }

    .banner-swiper {
      position: relative;
      width: 100%;
      overflow: hidden;
      border-radius: 11px;

      .banner-track {
        display: flex;
        transition: transform 0.4s ease;
      }

      .banner-slide {
        flex: 0 0 100%;

        .banner-img {
          width: 100%;
          display: block;
        }
      }

      .banner-dots {
        position: absolute;
        bottom: 10px;
        left: 50%;
        transform: translateX(-50%);
        display: flex;
        gap: 6px;
        z-index: 2;

        .dot {
          width: 6px;
          height: 6px;
          border-radius: 50%;
          background: rgba(255, 255, 255, 0.5);
          cursor: pointer;
          transition: background 0.3s;

          &.active {
            background: rgba(255, 255, 255, 1);
          }
        }
      }
    }

    .status-bar-img {
      width: 62px;
      height: 6px;
      display: block;
      margin: 6px auto 0;
    }
  }
}
</style>
